"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _constants = require("../../../packages/common-utilities/src/constants");

var _constants2 = _interopRequireDefault(_constants);

var _interactive_box = require("./interactive_box");

var _interactive_box2 = _interopRequireDefault(_interactive_box);

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _header_stats = require("./header_stats");

var _header_stats2 = _interopRequireDefault(_header_stats);

var _summary_header_credit_ratings = require("./summary_header_credit_ratings");

var _summary_header_credit_ratings2 = _interopRequireDefault(_summary_header_credit_ratings);

var _pdp_tabs = require("./pdp_tabs");

var _pdp_tabs2 = _interopRequireDefault(_pdp_tabs);

var _awards_and_ratings = require("./awards_and_ratings");

var _awards_and_ratings2 = _interopRequireDefault(_awards_and_ratings);

var _collection_utility = require("common-utilities/src/collection_utility");

var _sanitize_utility = require("common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _accessibility_utility = require("../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _ic_widget = require("./investment_comparison/ic_widget");

var _ic_widget2 = _interopRequireDefault(_ic_widget);

var _tracking_utility = require("../../../packages/common-utilities/src/tracking_utility");

var _location_service = require("../services/location_service");

var _location_service2 = _interopRequireDefault(_location_service);

var _error_boundary = require("./global_components/error_boundary");

var _error_boundary2 = _interopRequireDefault(_error_boundary);

var _state_service = require("../services/state_service");

var _state_service2 = _interopRequireDefault(_state_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PdpHeader = function (_React$Component) {
  _inherits(PdpHeader, _React$Component);

  function PdpHeader(props) {
    _classCallCheck(this, PdpHeader);

    var _this = _possibleConstructorReturn(this, (PdpHeader.__proto__ || Object.getPrototypeOf(PdpHeader)).call(this, props));

    _this.getFundNameForIpop = function () {
      return _this.props.fund.isUSCommingledFund ? _this.props.fund.name : _this.props.fund.disclosures['pdpFundName'];
    };

    _this.renderFeaturedFundIcon = function () {
      return _this.props.fund.fundFocusIndicator && (0, _functional_utility.doesVisibleDataPointContains)("SHOW_FEATURED_FUND_ICON", _this.props) && _react2.default.createElement("div", { id: "featured-fund-icon", className: "pdp-featured-fund-indicator display-inline-block" });
    };

    _this.trackICWidgetClickEvent = function () {
      _tracking_utility.TrackingUtility.trackEvent({
        'eventCategory': 'button',
        'eventAction': 'Compare this fund',
        'eventLabel': _this.props.window.location.pathname
      });
      _tracking_utility.TrackingUtility.trackEvent({
        'event': 'gaVirtualPageview',
        'virtualPath': "/vpv" + _this.props.window.location.pathname
      }, true, true);
    };

    _this.state = {
      morningStarRatingsAndAnalystRatingQty: null,
      icWidgetDisplayStyle: 'none'
    };
    _this.summaryHeaderFundDetailsRef = _react2.default.createRef();
    _this.icCompareButton = _react2.default.createRef();
    _location_service2.default.setTargetWindowObject(props.window);
    _this.renderInteractiveBox = _this.renderInteractiveBox.bind(_this);
    _this.renderHeaderStats = _this.renderHeaderStats.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    _this.openIcWidget = _this.openIcWidget.bind(_this);
    _this.renderIcWidget = _this.renderIcWidget.bind(_this);
    _this.closeIcWidget = _this.closeIcWidget.bind(_this);
    _this.globalStateSubscription = _state_service2.default.getGlobalState$().subscribe(function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.setState({ hasIcLiteRenderError: !!state.hasIcLiteRenderError });
    });
    return _this;
  }

  _createClass(PdpHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getMorningStarRatingsAndAnalystRatingQty();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.globalStateSubscription && this.globalStateSubscription.unsubscribe) {
        this.globalStateSubscription.unsubscribe();
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(disclosure, dataTest, tooltip, fundNameToDisplay) {
      var _this2 = this;

      if (!disclosure) {
        return null;
      }

      return _react2.default.createElement("span", { id: "disclosure-" + dataTest, tabIndex: 0, className: "icon-info print-hide",
        role: "button",
        "aria-label": "More information about- " + fundNameToDisplay,
        onKeyDown: function onKeyDown(event) {
          return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, dataTest, disclosure, tooltip));
        },
        onClick: function onClick(event) {
          return _this2.handleDisclosureIconClick(event, dataTest, disclosure, tooltip);
        }
      });
    }
  }, {
    key: "handleDisclosureIconClick",
    value: function handleDisclosureIconClick(event, dataTest, disclosure, tooltip) {
      var el = this.props.getIconEl(dataTest);
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 19;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (disclosure[0].length > 380) {
        if (this.props.breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      tooltip.openTooltip(elOffset, disclosure, null, true, event);
    }
  }, {
    key: "showFundRange",
    value: function showFundRange(breakpoint) {
      if (!(0, _functional_utility.doesVisibleDataPointContains)("HIDE_FUND_RANGE", this.props) && !(0, _ramda.isNil)(this.props.fund.fundRange)) {
        return _react2.default.createElement(
          "div",
          { id: "fund-range",
            className: "font-light " + (this.props.fund.fundRange === 'N/A' ? "display-none" : "display-block") + " " + (breakpoint < 3 ? "padding-bottom-10 " : "padding-bottom-20"),
            style: breakpoint > 3 ? { "paddingTop": "1.4px" } : {} },
          this.props.fund.fundRange === 'N/A' ? "" : _string_utility2.default.renderFormattedLabel(this.props.fund.fundRange, "pdp-fund-range-label-" + this.props.fund.fundRange)
        );
      }
      return null;
    }
  }, {
    key: "renderSummaryFundDetails",
    value: function renderSummaryFundDetails(fundNameToDisplay) {
      var _this3 = this;

      var breakpoint = this.props.breakpoint;


      return _react2.default.createElement(
        "div",
        { id: "summaryHeaderFundDetails",
          className: _functional_utility2.default.conditionCheck(breakpoint < 3, "padding-horizontal-0", "") + " col-xs-12 col-md-12 col-lg-12 col-xlg-12 funds-div margin-left-0 margin-right-0 pull-left",
          ref: this.summaryHeaderFundDetailsRef
        },
        _react2.default.createElement(
          "div",
          {
            className: "row margin-all-0" },
          _react2.default.createElement(
            "div",
            {
              className: "" + _functional_utility2.default.conditionCheck(breakpoint < 3, "display-inline-block float-left margin-top-18 line-height-15", "margin-top-30 line-height-20 margin-bottom-5") },
            this.props.renderBrandImage('sticky-header-disabled'),
            _react2.default.createElement(
              "div",
              { id: "summary-header-ticker-parent", className: "" + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, '', 'display-inline-flex'),
                style: { 'verticalAlign': 'text-bottom', 'align-items': 'center' } },
              this.props.fund.isDigitalShareFund ? _react2.default.createElement("span", { className: "fx-digital-share-fund-indicator", style: breakpoint < 3 ? { "margin-bottom": "-5px" } : {} }) : null,
              this.renderFeaturedFundIcon(),
              this.renderSummaryHeaderTicker(breakpoint),
              breakpoint > 2 && this.props.showShareclassSelector(false)
            )
          )
        ),
        _react2.default.createElement(
          "h1",
          {
            className: "print-BP4-font-sub-header " + _functional_utility2.default.conditionCheck(breakpoint < 3, "header-2 margin-bottom-30 padding-top-10", "header margin-bottom-40"),
            ref: function ref(div) {
              _this3.fundNameEl = div;
            },
            id: "fund-name", "data-testid": "summary-header-fund-name" },
          _react2.default.createElement(
            "div",
            { className: "margin-all-0" },
            fundNameToDisplay,
            this.props.renderDashShareclass(),
            this.props.renderFundNameDisclosure(),
            _react2.default.createElement(
              "span",
              { className: "caption margin-left-5",
                style: { 'verticalAlign': 'middle' } },
              this.renderIcon(this.getFundNameForIpop(), 'fund-name', this.props.tooltip, fundNameToDisplay)
            ),
            !(0, _functional_utility.isNilOrEmpty)(this.props.fund.managementCompanyName) && _react2.default.createElement(
              "div",
              { className: "caption padding-top-5", "data-testid": "fund-company-management-name" },
              this.props.fund.managementCompanyName
            )
          )
        ),
        this.showFundRange(breakpoint),
        breakpoint < 3 && this.props.showShareclassSelector(false),
        breakpoint > 2 && this.renderSummaryHeaderCreditRatings(false)
      );
    }
  }, {
    key: "renderSummaryHeaderTicker",
    value: function renderSummaryHeaderTicker(breakpoint) {
      if ((0, _functional_utility.doesVisibleDataPointContains)("SHOW_VALOREN", this.props)) {
        return _react2.default.createElement(
          "div",
          { id: "header-valoren",
            className: "font-regular print-BP4-font-ticker capital-letter-spacing " + (this.props.fund.shareClass.valoren === 'N/A' ? "display-none" : "display-block") + " display-inline-block float-left margin-right-20",
            style: breakpoint > 3 ? { "paddingTop": "1.4px" } : {} },
          (0, _ramda.isNil)(this.props.fund.shareClass.valoren) ? "" : "Valor " + this.props.fund.shareClass.valoren
        );
      } else if (!(0, _functional_utility.doesVisibleDataPointContains)("SUPPRESS_HEADER_TICKER", this.props)) {
        return _react2.default.createElement(
          "div",
          { id: "ticker", "data-testid": "header-ticker",
            className: "font-regular print-BP4-font-ticker capital-letter-spacing " + (this.props.fund.shareClass.headerTicker === 'N/A' ? "display-none" : "display-block") + " display-inline-block float-left margin-right-20",
            style: breakpoint > 3 ? { "paddingTop": "1.4px" } : {} },
          this.props.fund.shareClass.headerTicker === 'N/A' ? "" : this.props.fund.shareClass.headerTicker
        );
      } else {
        return null;
      }
    }
  }, {
    key: "renderSummaryHeaderCreditRatings",
    value: function renderSummaryHeaderCreditRatings(isMobileBreakpoint) {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ENABLE_SUMMARY_HEADER_INDUSTRY_RATINGS')) {
        var summaryHeaderCreditRatings = _react2.default.createElement(_summary_header_credit_ratings2.default, {
          country: this.props.country,
          fundIndustryCreditRatings: this.props.fund.fundIndustryCreditRatings,
          breakpoint: this.props.breakpoint,
          role: this.props.role,
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints
        });
        if (isMobileBreakpoint) {
          return _react2.default.createElement(
            "div",
            { className: "row margin-all-0" },
            _react2.default.createElement(
              "div",
              { className: "col-xs-12 col-sm-12 col-md-10 col-lg-9 col-xlg-9 padding-horizontal-0" },
              summaryHeaderCreditRatings
            )
          );
        } else {
          return _react2.default.createElement(
            "div",
            { className: "margin-all-0" },
            summaryHeaderCreditRatings
          );
        }
      }
    }
  }, {
    key: "renderSummaryHeaderDisclosure",
    value: function renderSummaryHeaderDisclosure() {
      var disclosureText = void 0;

      if ((0, _ramda.includes)("SHOW_SUMMARY_HEADER_DISCLOSURE", this.props.fund.visibleData.visibleDataPoints)) {
        disclosureText = (0, _ramda.pathOr)(null, ["disclosures", "pdpSummaryHeader"], this.props.fund);
      } else if ((0, _ramda.includes)("SHOW_SUMMARY_HEADER_DISCLOSURE_FR", this.props.fund.visibleData.visibleDataPoints)) {
        disclosureText = (0, _ramda.pathOr)(null, ["disclosures", "pdpSumamryHeader"], this.props.fund);
      }
      if (!(0, _functional_utility.isNilOrEmpty)(disclosureText)) {
        return _react2.default.createElement("div", { "data-testid": "pdpSummaryHeaderDisclosure",
          className: (_functional_utility2.default.isMobileBreakpoint(this.props.breakpoint) ? 'padding-vertical-10' : 'padding-top-20') + " \n                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 font-light caption",
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosureText) } });
      }
    }
  }, {
    key: "renderSummaryHeaderRoleDisclosure",
    value: function renderSummaryHeaderRoleDisclosure() {
      var disclosureText = void 0;

      if ((0, _ramda.includes)("SHOW_SUMMARY_HEADER_DISCLOSURE_ADV", this.props.fund.visibleData.visibleDataPoints)) {
        disclosureText = (0, _ramda.pathOr)(null, ["disclosures", "pdpSummaryHeaderAdv"], this.props.fund);
      } else if ((0, _ramda.includes)("SHOW_SUMMARY_HEADER_DISCLOSURE_PER", this.props.fund.visibleData.visibleDataPoints)) {
        disclosureText = (0, _ramda.pathOr)(null, ["disclosures", "pdpSummaryHeaderPer"], this.props.fund);
      }

      if (!(0, _functional_utility.isNilOrEmpty)(disclosureText)) {
        return _react2.default.createElement("div", { "data-testid": "pdpSummaryHeaderRoleDisclosure",
          className: (_functional_utility2.default.isMobileBreakpoint(this.props.breakpoint) ? 'padding-vertical-10' : 'padding-top-20') + " \n                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 font-light caption",
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosureText) } });
      }
    }
  }, {
    key: "renderPastPerformanceDisclosure",
    value: function renderPastPerformanceDisclosure() {
      if (!(0, _ramda.includes)("SHOW_SUMMARY_HEADER_PAST_PERFROMANCE_DISCLOSURE", this.props.fund.visibleData.visibleDataPoints)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { "data-testid": "pdpSummaryHeaderPastPerfDisclosure",
          className: (_functional_utility2.default.isMobileBreakpoint(this.props.breakpoint) ? 'padding-vertical-10' : 'padding-top-20') + " col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 font-light caption" },
        _string_utility2.default.renderFormattedLabel('Past performance is not a guide to current and future performance.', 'pdp-summary-header-disclosure')
      );
    }
  }, {
    key: "renderMorningStarCategoryForEmea",
    value: function renderMorningStarCategoryForEmea() {
      var fund = this.props.fund;


      var morningstarMedalistRatingIndicator = (0, _ramda.pathOr)(null, ["shareClass", "morningstarOverallRating", "morningstarMedalistRatingIndicator"], fund);
      var morningstarCategoryIsNull = (0, _ramda.pathSatisfies)(_ramda.isNil, ["shareClass", "morningstarRatingCategory"], fund);
      var medalistRatingIndicator = _constants2.default.getMedalistRatingIndicator(morningstarMedalistRatingIndicator);
      var morningstarRating = (0, _ramda.find)((0, _ramda.propEq)("periodIndicator", "OVR"))((0, _ramda.pathOr)([], ["shareClass", "morningstarRating"], fund));
      var hasValidMorningstarRating = true;
      if ((0, _ramda.isNil)(morningstarRating) || morningstarRating && morningstarRating.rankNumber < 4) {
        hasValidMorningstarRating = false;
      }
      if (!(0, _ramda.includes)("SHOW_MORNING_STAR_CATEGORY", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], fund)) || morningstarCategoryIsNull) {
        return null;
      }

      if (hasValidMorningstarRating || medalistRatingIndicator) {
        return _react2.default.createElement(
          "div",
          { "data-testid": "emea-morningstar-category",
            className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 font-light disclaimer margin-top-40" },
          _string_utility2.default.renderFormattedLabel('Morningstar Category™:', 'pdp-summary-header-morningstar-category-label', { role: this.props.role }),
          " ",
          fund.shareClass.morningstarRatingCategory
        );
      }
    }
  }, {
    key: "renderInteractiveBox",
    value: function renderInteractiveBox(fundNameToDisplay) {
      var documentTag = _constants2.default.getFdTagConstants();

      var aemDoc = {};
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.content)) {
        var docList = void 0;
        if ((0, _ramda.pathOr)(false, ["content", "documents", (0, _ramda.toUpper)(this.props.cusip)], this.props)) {
          docList = this.props.content.documents[(0, _ramda.toUpper)(this.props.cusip)];
        }

        if (!(0, _functional_utility.isNilOrEmpty)(docList)) {
          for (var i = 0; i < docList.length; i++) {
            if (docList[i].documentType === documentTag.FACT_SHEET) {
              if (!_functional_utility2.default.isNilOrEmpty(docList[i].language) && 'zh' === docList[i].language) {
                aemDoc[documentTag.FACT_SHEET + "_zh"] = docList[i];
              } else {
                aemDoc[documentTag.FACT_SHEET] = docList[i];
              }
            } else if (docList[i].documentType === documentTag.COMMENTARY) {
              aemDoc[documentTag.COMMENTARY] = docList[i];
            } else if (docList[i].documentType === documentTag.SUMMARY_PROSPECTUS) {
              aemDoc[documentTag.SUMMARY_PROSPECTUS] = docList[i];
            } else if (docList[i].documentType === documentTag.KIID_OEIC) {
              aemDoc[documentTag.KIID_OEIC] = docList[i];
            } else if (docList[i].documentType === documentTag.PRIIP_KID) {
              if ((0, _functional_utility.isNilOrEmpty)(aemDoc[documentTag.PRIIP_KID]) || !(0, _ramda.isNil)(docList[i].docURL) && docList[i].docURL.indexOf(_constants.KID_PREFERRED_URL_CONTAINS_STRING) > -1) {
                aemDoc[documentTag.PRIIP_KID] = docList[i];
              }
            } else if (docList[i].documentType === documentTag.PROSPECTUS) {
              aemDoc[documentTag.PROSPECTUS] = docList[i];
            } else if (docList[i].documentType === documentTag.INVESTOR_DISCLOSURE_DOCUMENT) {
              aemDoc[documentTag.INVESTOR_DISCLOSURE_DOCUMENT] = docList[i];
            } else if (docList[i].documentType === documentTag.PREFERENCE_CENTRE) {
              aemDoc[documentTag.PREFERENCE_CENTRE] = docList[i];
            } else if (docList[i].documentType === documentTag.FUND_STORY) {
              aemDoc[documentTag.FUND_STORY] = docList[i];
            } else if (docList[i].documentType === documentTag.PRODUCT_DISCLOSURE_STATEMENT) {
              aemDoc[documentTag.PRODUCT_DISCLOSURE_STATEMENT] = docList[i];
            }
          }
        }
      }

      var isRatingsFromFundPerformanceRatings = !_functional_utility2.default.isNilOrEmpty(this.props.fund.fundPerformanceRatings) && (0, _ramda.any)(function (rating) {
        return !rating.isAward;
      })(this.props.fund.fundPerformanceRatings);

      var isMorningStarRatingsAndAnalystRating = !(0, _ramda.isNil)(this.state.morningStarRatingsAndAnalystRatingQty) && this.state.morningStarRatingsAndAnalystRatingQty !== 0;

      var isAwardsAndRatingsAvailable = isRatingsFromFundPerformanceRatings || isMorningStarRatingsAndAnalystRating;

      if (!_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesQuickLinksConstants(), this.props.role) && !_collection_utility.CollectionUtility.includes(this.props.fund.visibleDataPoints, 'HIDE_INTERACTIVE_BOX')) {
        return _react2.default.createElement(_interactive_box2.default, {
          cusip: this.props.cusip,
          jpETFCusip: this.props.fund.shareClass.cusip,
          ticker: this.props.fund.shareClass.ticker,
          fundTypeCode: this.props.fund.fundTypeCode,
          userLoggedIn: this.props.userLoggedIn,
          breakpoint: this.props.breakpoint,
          role: this.props.role,
          country: this.props.country,
          basePath: this.props.basePath,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          window: this.props.window,
          fundDocuments: this.props.fund.fundDocuments,
          cmsShare: this.props.fund.cmsShare,
          language: this.props.language,
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
          compareFundLink: this.props.fund.compareFundLink,
          kiidUrl: this.props.fund.kiidUrl,
          factsheetUrl: this.props.fund.factsheetUrl,
          aemDoc: aemDoc,
          howToBuyLink: this.props.fund.howToBuyLink,
          howToInvestLink: this.props.fund.howToInvestLink,
          howToBuyETFLink: this.props.fund.howToBuyETFLink,
          fundHighlightsLink: this.props.fund.fundHighlightsLink,
          renderJumpToFundApp: this.props.renderJumpToFundApp,
          summaryHeaderHeight: (0, _ramda.isNil)(this.summaryHeaderFundDetailsRef.current) ? 0 : this.summaryHeaderFundDetailsRef.current.offsetHeight,
          fundIndustryCreditRatings: this.props.fund.fundIndustryCreditRatings,
          isAwardsAndRatingsAvailable: isAwardsAndRatingsAvailable,
          isAEM: this.props.isAEM,
          isFavoriteFund: this.props.fund.isFavoriteFund,
          fundDisplayName: fundNameToDisplay,
          intl: this.props.intl,
          tooltip: this.props.tooltip
        });
      }
    }
  }, {
    key: "renderPortfolioImage",
    value: function renderPortfolioImage(heroImageURL) {
      return _react2.default.createElement(
        "div",
        { className: "row margin-left-0 margin-right-0 overflow-hidden height-91" },
        _react2.default.createElement("img", { className: "portfolio-image print-hide", "data-testid": "hero-image-url",
          src: heroImageURL })
      );
    }
  }, {
    key: "renderHeaderStats",
    value: function renderHeaderStats() {
      var _this4 = this;

      var _props = this.props,
          fund = _props.fund,
          gaiaRedirectUrl = _props.gaiaRedirectUrl,
          breakpoint = _props.breakpoint;

      var isMobileView = breakpoint < 3;
      var isERDDisclosurePresent = _collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'ERD_DISCLOSURE');
      var rowElementClassName = _functional_utility2.default.conditionCheck(isMobileView, "row margin-all-0", "row margin-horizontal-0");
      var headerStatsWrapperClassName = _functional_utility2.default.conditionCheck(isMobileView, "header-stats-wrapper width-percent-100 padding-horizontal-15 margin-bottom-30", "container header-stats-wrapper");

      var headerStatsExtraLargeDesktopClassName = _functional_utility2.default.conditionCheck((0, _ramda.includes)("BOOTSTRAP_COLUMN_FULL_WIDTH", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], fund)), "col-xlg-12", "col-xlg-12");
      var shouldRenderAwardsAndRatings = !(0, _functional_utility.doesVisibleDataPointContains)("SHOW_AWARDS_AND_RATINGS", this.props);
      var headerStatClassName = "col-xs-12 col-sm-12";
      headerStatClassName += " col-md-12 col-lg-12";

      var erdContent = (0, _ramda.includes)("SEMI_TRANSPARENT_INDICATOR_PRESENT", this.props.fund.visibleData.visibleDataPoints) ? (0, _ramda.pathOr)(null, ["disclosures", "pdpTopETFSemiTransparent"], this.props.fund) : (0, _ramda.pathOr)(null, ["disclosures", "pdpSummaryERD"], this.props.fund);

      if (isERDDisclosurePresent && !(0, _ramda.isNil)(erdContent)) {
        headerStatClassName = "col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-0";
        headerStatsWrapperClassName += ' padding-all-0';
      }

      return _react2.default.createElement(
        "div",
        {
          className: headerStatsWrapperClassName,
          ref: function ref(div) {
            return _this4.headerStatsWrapper = div;
          }
        },
        _react2.default.createElement(
          "div",
          { className: rowElementClassName },
          _react2.default.createElement(
            "div",
            { className: headerStatClassName + " " + headerStatsExtraLargeDesktopClassName },
            _react2.default.createElement(_header_stats2.default, {
              fund: fund,
              breakpoint: breakpoint,
              visibleDataPoints: fund.visibleData.visibleDataPoints,
              formattingRules: fund.visibleData.formattingRules,
              disclosures: fund.disclosures,
              gaiaRedirectUrl: gaiaRedirectUrl,
              tooltip: this.props.tooltip,
              country: this.props.country,
              role: this.props.role,
              customHeaderStats: shouldRenderAwardsAndRatings && isMobileView,
              intl: this.props.intl
            })
          ),
          !isMobileView && this.renderERDDisclosure(),
          isMobileView && this.renderPastPerformanceDisclosure(),
          isMobileView && this.renderSummaryHeaderDisclosure(),
          isMobileView && this.renderSummaryHeaderRoleDisclosure(),
          isMobileView && this.renderERDDisclosure()
        )
      );
    }
  }, {
    key: "getMorningStarRatingsAndAnalystRatingQty",
    value: function getMorningStarRatingsAndAnalystRatingQty() {
      var result = 0;
      result += (0, _awards_and_ratings.isMorningStarPresent)(this.props.fund.shareClass, this.props) ? 1 : 0;
      result += (0, _awards_and_ratings.isMorningStarAnalystRatingPresent)(this.props.fund.shareClass, this.props) ? 1 : 0;
      this.setState({ morningStarRatingsAndAnalystRatingQty: result });
    }
  }, {
    key: "renderAwardsAndRatings",
    value: function renderAwardsAndRatings() {
      return _react2.default.createElement(_awards_and_ratings2.default, {
        breakpoint: this.props.breakpoint,
        fund: this.props.fund,
        role: this.props.role,
        tooltip: this.props.tooltip,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        additionalRatings: this.props.additionalRatings,
        additionalRatingsHandler: this.props.additionalRatingsHandler,
        intl: this.props.intl
      });
    }
  }, {
    key: "renderJTFForMobile",
    value: function renderJTFForMobile() {
      return _react2.default.createElement(
        "div",
        { className: "container-fluid background-pale-grey-two padding-all-0" },
        this.props.renderJumpToFundApp()
      );
    }
  }, {
    key: "reformatERDDisclosure",
    value: function reformatERDDisclosure(disclosure) {
      if ((0, _functional_utility.isNilOrEmpty)(disclosure)) {
        return null;
      }

      var erdList = disclosure[0].split("\n");
      var erdHTML = "<ul>";

      erdHTML = _collection_utility.CollectionUtility.reduce(erdList, function (result, current) {
        return result + "<li>" + current + "</li>";
      }, erdHTML);

      return erdHTML + "</ul>";
    }
  }, {
    key: "renderERDDisclosure",
    value: function renderERDDisclosure() {
      var erdContent = (0, _ramda.includes)("SEMI_TRANSPARENT_INDICATOR_PRESENT", this.props.fund.visibleData.visibleDataPoints) ? (0, _ramda.pathOr)(null, ["disclosures", "pdpTopETFSemiTransparent"], this.props.fund) : (0, _ramda.pathOr)(null, ["disclosures", "pdpSummaryERD"], this.props.fund);
      return _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ERD_DISCLOSURE') && !(0, _ramda.isNil)(erdContent) ? _react2.default.createElement("div", {
        className: "disclaimer col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-horizontal-0 padding-top-15 margin-top-10 margin-bottom-25",
        "data-testid": "erd-disclosure",
        id: "erd-disclosure",
        style: { 'line-height': '1.43' },
        dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.reformatERDDisclosure(erdContent)) } }) : null;
    }
  }, {
    key: "renderHeroImage",
    value: function renderHeroImage() {
      var showHeroImage = (0, _functional_utility.doesVisibleDataPointContains)("SHOW_SUMMARY_HEADER_IMAGE", this.props);
      var heroImageURL = !(0, _ramda.isNil)(this.props.content) && !(0, _ramda.isNil)(this.props.content.pdpHeroImage) && !(0, _ramda.isEmpty)((0, _ramda.trim)(this.props.content.pdpHeroImage)) ? this.props.content.pdpHeroImage : null;
      var isMobile = (0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint);

      return showHeroImage && !(0, _ramda.isNil)(heroImageURL) ? _react2.default.createElement(
        "div",
        null,
        !isMobile && _react2.default.createElement("img", { className: "pdp-summary-header-blur-img", src: heroImageURL }),
        _react2.default.createElement("img", { className: "pdp-summary-header-img" + (isMobile ? " mobile" : ""), src: heroImageURL })
      ) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var breakpoint = this.props.breakpoint;


      _functional_utility2.default.ifMobileBreakpoint(breakpoint, "", "pdp-summary-header-background");
      var fundNameToDisplay = (0, _functional_utility.doesVisibleDataPointContains)("SHOW_SHARECLASS_NAME", this.props) ? this.props.fund.shareClass.name : this.props.fund.name;
      (0, _functional_utility.doesVisibleDataPointContains)("SHOW_AWARDS_AND_RATINGS", this.props);
      var isIcDataAvailable = (0, _functional_utility.pathOrEmptyArray)(['icData', 'figiIDs'], this.props).length > 0 && !(0, _functional_utility.isNilOrEmpty)((0, _functional_utility.pathOrNull)(['icData', 'data'], this.props));
      var hasIcDataError = this.props.icMessageStatus === 'ic initialization error';
      var showInvestmentComparison = (0, _functional_utility.doesVisibleDataPointContains)("SHOW_INVESTMENT_COMPARISON_LITE", this.props) && isIcDataAvailable && !this.state.hasIcLiteRenderError && !hasIcDataError;
      return _react2.default.createElement(
        "div",
        null,
        this.props.renderSummaryAlerts(),
        this.renderHeroImage(),
        _react2.default.createElement(
          "div",
          { className: "line-height-38 fluid-container " + this.props.summaryHeaderBackgroundColor },
          _react2.default.createElement(
            "div",
            { "data-testid": "hero-image-background",
              className: "pdp-summary-header-background header-background print-hide-image print-white-background" },
            _react2.default.createElement(
              "div",
              {
                className: "" + _functional_utility2.default.ifMobileBreakpoint(breakpoint, "", "container") },
              _react2.default.createElement(
                "div",
                { id: "pdpHeader", className: "row margin-left-0 margin-right-0 " + _functional_utility2.default.ifMobileBreakpoint(breakpoint, "", "margin-bottom-20") },
                _react2.default.createElement(
                  "div",
                  { className: "row" },
                  _react2.default.createElement(
                    "div",
                    { className: "col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xlg-9 " + _functional_utility2.default.ifMobileBreakpoint(breakpoint, "padding-horizontal-15 padding-bottom-30", "padding-right-20 padding-left-0") },
                    this.renderSummaryFundDetails(fundNameToDisplay),
                    this.renderAwardsAndRatings(),
                    breakpoint > 2 && this.renderMorningStarCategoryForEmea(),
                    breakpoint < 3 && this.renderSummaryHeaderCreditRatings(true)
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-3 padding-all-0" },
                    this.renderInteractiveBox(fundNameToDisplay)
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: "row" },
                  _react2.default.createElement(
                    "div",
                    { className: "col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xlg-9 margin-all-0 padding-all-0" },
                    breakpoint > 2 && this.renderPastPerformanceDisclosure(),
                    breakpoint > 2 && this.renderSummaryHeaderDisclosure(),
                    breakpoint > 2 && this.renderSummaryHeaderRoleDisclosure()
                  )
                )
              )
            )
          )
        ),
        showInvestmentComparison && breakpoint > 3 && !_location_service2.default.isMobileInsight(this.props.basePath) && this.props.role !== _constants2.default.getOrionRole() && _react2.default.createElement(
          "div",
          { className: "row compare-fund-container " + _functional_utility2.default.isBreakpointThree(breakpoint, "margin-horizontal-0", "") },
          _react2.default.createElement(
            "div",
            { className: "container" },
            _react2.default.createElement(
              "div",
              { className: "row" },
              _react2.default.createElement(
                "div",
                { className: "col-sm-8 col-md-8 col-lg-9 col-xlg-9 padding-left-25 padding-right-5 padding-vertical-20 font-white compare-fund-button-container-left" },
                _react2.default.createElement(
                  "span",
                  { "data-testid": "btn-compare-fund-intro-text" },
                  _string_utility2.default.renderFormattedLabel("Get an instant comparison of this fund with over 35,000 investments", "pdp-ic-btn-compare-fund-intro-text")
                )
              ),
              _react2.default.createElement(
                "div",
                { ref: this.icCompareButton, tabIndex: 0, "data-testid": "btn-compare-fund", className: "col-sm-4 col-md-4 col-lg-3 col-xlg-3 padding-vertical-20 padding-horizontal-20 compare-fund-button-container-right",
                  onKeyDown: function onKeyDown(event) {
                    return _accessibility_utility2.default.handleEnterClick(_this5, event, _this5.openIcWidget.bind(_this5, event));
                  },
                  onClick: function onClick() {
                    return _this5.openIcWidget();
                  } },
                _react2.default.createElement(
                  "div",
                  { className: "compare-fund-button-wrapper" },
                  _react2.default.createElement(
                    "span",
                    { className: "tag display-inline-block width-percent-80" },
                    _string_utility2.default.renderFormattedLabel("Compare this fund", "pdp-ic-btn-compare-this-investment")
                  ),
                  _react2.default.createElement("span", { className: "rocket-icon pull-right" })
                )
              )
            ),
            this.renderIcWidget(fundNameToDisplay)
          )
        ),
        this.renderHeaderStats(),
        (0, _functional_utility.isMobileBreakpoint)(breakpoint) && this.renderJTFForMobile(),
        this.renderTabs()
      );
    }
  }, {
    key: "openIcWidget",
    value: function openIcWidget() {
      document.body.style.overflow = "hidden";
      this.setState({
        open: true
      });
      this.trackICWidgetClickEvent();
    }
  }, {
    key: "closeIcWidget",
    value: function closeIcWidget() {
      var _this6 = this;

      this.setState({ open: false });
      document.body.style.overflow = "auto";
      if (!(0, _ramda.isNil)(this.icCompareButton)) {
        setTimeout(function () {
          _this6.icCompareButton.current.focus();
        }, 500);
      }
    }
  }, {
    key: "renderIcWidget",
    value: function renderIcWidget(fundNameToDisplay) {
      return _react2.default.createElement(
        _error_boundary2.default,
        null,
        _react2.default.createElement(
          "div",
          { "data-testid": "ic-widget" },
          _react2.default.createElement(_ic_widget2.default, {
            breakpoint: this.props.breakpoint,
            open: this.state.open,
            closeOverlay: this.closeIcWidget,
            ticker: this.props.fund.shareClass.headerTicker === 'N/A' ? "" : this.props.fund.shareClass.headerTicker,
            fundName: fundNameToDisplay,
            shareclassCategoryCode: this.props.fund.shareClass.categoryCode,
            disclosures: this.props.fund.disclosures,
            historicalData: this.props.historicalData,
            role: this.props.role,
            country: this.props.country,
            language: this.props.language,
            icData: this.props.icData,
            icMessageStatus: this.props.icMessageStatus,
            userLoggedIn: this.props.userLoggedIn,
            currencyCode: this.props.fund.currencyCode,
            gaiaRedirectUrl: this.props.gaiaRedirectUrl,
            intl: this.props.intl,
            numberFormat: this.props.numberFormat,
            tooltip: this.props.tooltip,
            window: this.props.window,
            cmsHost: this.props.cmsHost
          })
        )
      );
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var _props2 = this.props,
          tabProps = _props2.tabProps,
          listOfAllTabs = _props2.listOfAllTabs,
          updateTabState = _props2.updateTabState,
          fund = _props2.fund,
          isTabOrMobileBP = _props2.isTabOrMobileBP;

      return _react2.default.createElement(_pdp_tabs2.default, {
        tabProps: tabProps,
        listOfAllTabs: listOfAllTabs,
        updateTabState: updateTabState,
        isTabOrMobileBP: isTabOrMobileBP,
        fundTypeCode: fund.fundTypeCode });
    }
  }]);

  return PdpHeader;
}(_react2.default.Component);

exports.default = PdpHeader;